import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app"
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, productsMatcherItems, productsMatcherGroupedProductIDs} from "../@signals";
import useProductsMatcherItems from "./useItems";


export default function useProductsMatcherTarget() {
	const { handleSubmit, handleMoreProducts } = useProductsMatcherItems()
	const { showToast } = useAppToast()

	const selected = useSignal(null)
	const isQA = useSignal(false)
	const isLoadingMapping = useSignal(false)
	const targetIndex = useSignal(0)
	const targetData = productsMatcherItems.value[targetIndex.value] || {}

	useEffect(() => {
		setSelectedSKU(targetData?.AIOptions?.[0]?.productID ?? null, false)
		if ((targetIndex.value + 1) > productsMatcherItems.value.length)
			handleSubmit()
	}, [targetIndex.value])

	const __showToast = () => showToast.error(
		`Product ${targetData.ownProductID} (site ${targetData.siteID}) failed!`, {
			position: "top-left"
		})

	const setSelectedSKU = useCallback((newValue, saveByQa=true) => {
		selected.value = newValue
		isQA.value = saveByQa
	}, [])

	const setTargetIndex = useCallback(newValue => {
		targetIndex.value = newValue
		batch(() => isLoadingMapping.value = false)
	}, [JSON.stringify(targetData)])

	const saveMapping = useCallback((notFound=false, group=true) => {
		isLoadingMapping.value = true

		const productID = !notFound ? selected.value : null
		const additionalProductIDs = [...productsMatcherGroupedProductIDs.value]
		setTargetIndex(targetIndex.value + 1)

		// Clear grouped product IDs after capturing them
		productsMatcherGroupedProductIDs.value = []

		// Single API call - backend materializes PRODUCT_MATCH (local writer)
		postSubmit(`${BACKEND_APIS.MATCHERS}/products/mapping-product`, {
			productID: productID,
			mappingID: targetData.mappingID,
			notFound: notFound,
			qa: true,
			additionalProductIDs: additionalProductIDs,
			group: group
		}).catch(e => {
			console.error('ERROR MATCHING PRODUCT', e)
			__showToast()
		})
	}, [JSON.stringify(targetData), selected.value])

	return {
		targetIndex: targetIndex.value,
		targetData: targetData,
		selectedSKU: selected.value,
		isLoadingMapping: isLoadingMapping.value,

		finishItems: !isLoadMoreItems.value && targetIndex.value >= productsMatcherItems.value.length,
		needMorItems: isLoadMoreItems.value && targetIndex.value >= productsMatcherItems.value.length,

		setSelectedSKU,
		setTargetIndex,
		saveMapping,
		handleMoreProducts
	}
}